import React from 'react'
import { Col, Form } from 'antd'
import { useTranslation } from 'lib/i18n'

import InputWithoutAutoComplete from 'components/InputWithoutAutoComplete/InputWithoutAutoComplete'
import {
  VIDEO_REQUEST_IS_GIFT,
  VIDEO_REQUEST_TO_NAME,
  VIDEO_REQUEST_TO_PRONOUN,
} from 'components/ProductPage/shared/FieldConstants'
import PronounOptions from 'components/ProductPage/shared/PronounOptions'

function ToField({ label, isGift }) {
  const { t } = useTranslation()

  return (
    <Form.Item
      name={VIDEO_REQUEST_TO_NAME}
      label={label}
      rules={[
        {
          required: true,
          message: t(
            'VideoRequestForm.toRequired',
            'Fill in the recipients name',
          ),
        },
      ]}
      data-cy="toName"
    >
      <InputWithoutAutoComplete
        size="large"
        placeholder={
          isGift
            ? t(
                'ToName.toNamePlaceholderGift',
                'Name who will receive the video',
              )
            : t('ToName.toNamePlaceholderMyself', 'Tell us your name')
        }
      />
    </Form.Item>
  )
}

export default function VideoRequestToName({ pronouns, theme = 'red' }) {
  const { t } = useTranslation()

  return (
    <>
      <Form.Item shouldUpdate>
        {({ getFieldValue }) => {
          const isGift = getFieldValue(VIDEO_REQUEST_IS_GIFT)
          return (
            <Col>
              <ToField label={t('ToName.toTitle2', 'To')} isGift={isGift} />
            </Col>
          )
        }}
      </Form.Item>

      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue, setFieldsValue }) => (
          <Form.Item name={VIDEO_REQUEST_TO_PRONOUN}>
            <PronounOptions
              pronouns={pronouns}
              onChange={setFieldsValue}
              selected={getFieldValue(VIDEO_REQUEST_TO_PRONOUN)}
              isInverted
              theme={theme}
            />
          </Form.Item>
        )}
      </Form.Item>
    </>
  )
}
